import { firebaseAction } from "vuexfire";
import firebase from "firebase/app";
import axios from "axios";
import constants from "@/config/constants";
import i18n from "@/config/i18n";

export default {
  namespaced: true,
  state: {
    current: {},
  },
  getters: {},

  actions: {
    setCurrentUser: firebaseAction(({ bindFirebaseRef }, ref) => {
      bindFirebaseRef("current", ref);
    }),

    checkVersion: function (context, user) {
      return new Promise((resolve) => {
        firebase
          .database()
          .ref("users/" + user.uid + "/fbversion")
          .once("value", (snapShot) => {
            if (
              snapShot.val() === null ||
              snapShot.val() < constants.currentVersion
            ) {
              axios
                .post(constants.cloudFunctionsBasePath + "/migration", {
                  userID: user.uid,
                })
                .then(() => {
                  let listener = firebase
                    .database()
                    .ref("users/" + user.uid + "/fbversion");
                  listener.on("value", (snapShot) => {
                    let version = snapShot.val();
                    if (version === 2) {
                      listener.off("value");
                      resolve();
                    }
                  });
                })
                .catch(() => resolve());
            } else resolve();
          });
      });
    },

    updateUser: function (context, form) {
      return new Promise((resolve) => {
        firebase
          .database()
          .ref("users/" + context.state.current.uid)
          .update({
            firstname: form.name,
            lastname: form.lastName,
          })
          .then(() => resolve());
      });
    },

    updatePassword: function (context, form) {
      return new Promise((resolve, reject) => {
        firebase
          .auth()
          .currentUser.reauthenticateWithCredential(
            firebase.auth.EmailAuthProvider.credential(
              firebase.auth().currentUser.email,
              form.oldPassword
            )
          )
          .then(() => {
            firebase
              .auth()
              .currentUser.updatePassword(form.newPassword)
              .then(() => {
                firebase
                  .auth()
                  .currentUser.reauthenticateWithCredential(
                    firebase.auth.EmailAuthProvider.credential(
                      firebase.auth().currentUser.email,
                      form.newPassword
                    )
                  )
                  .then(() => {
                    resolve();
                  });
              })
              .catch(() => {
                reject(i18n.t("user.password.minLengthError"));
              });
          })
          .catch(() => reject(i18n.t("user.password.oldPasswordError")));
      });
    },
  },
};
